// extracted by mini-css-extract-plugin
export default {"tabsContainer":"NominalAccount_tabsContainer__69T5i"};